module.exports = __webpack_public_path__ + "static/media/bg6.fb4b96f0.jpg";